import { Axios } from "../hooks/useAxiosInstance";

export const Donate = (function () {

    // const { api_token } = useSelector(state => state.profile);

    const apis = () => ({
        fetch: async ({ api_token }) => await fetchRecord(api_token),
        delete: async (slug, api_token) => await deleteRecord(slug, api_token),
    })

    async function fetchRecord(api_token) {
        const url = "api/admin/donate";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.get(url, option);
    }

    async function deleteRecord(slug, api_token) {
        const url = "api/admin/donate/" + slug;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.delete(url, option);
    }

    return apis();

})()
